import { render, staticRenderFns } from "./big-growth-camp.vue?vue&type=template&id=5fb4b047"
import script from "./big-growth-camp.vue?vue&type=script&lang=ts"
export * from "./big-growth-camp.vue?vue&type=script&lang=ts"
import style0 from "./big-growth-camp.vue?vue&type=style&index=0&id=5fb4b047&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports